<template>
  <button @click="$emit('click')">
    <i :class="'fa fa-' + icon"></i>
    <span>{{ title }}</span>
  </button>

</template>

<script>
  export default {
    props: {
      icon: {
        type: String
      },
      title: {
        type: String,
        required: true
      }
    }
  }
</script>

<style scoped>
  button > span {
    font-variant: small-caps;
  }
</style>
